export const ROLES = {
  ADMIN_SUPER: "admin_super",
  ADMIN_UNIV: "admin_univ",
  ADMIN_KEPEGAWAIAN: "admin_kepegawaian",
  ADMIN_HTL: "admin_htl",
  ADMIN_FAKULTAS: "admin_fakultas",
  DOSEN: "dosen",
};

export const ROLE_REDIRECT_MAP = {
  [ROLES.ADMIN_SUPER]: "/admin/dashboard",
  [ROLES.ADMIN_UNIV]: "/admin/remun-dosen",
  [ROLES.ADMIN_KEPEGAWAIAN]: "/admin/validasi-jabatan",
  [ROLES.ADMIN_HTL]: "/admin/validasi-jabatan",
  [ROLES.ADMIN_FAKULTAS]: "/admin/remun-dosen",
  [ROLES.DOSEN]: "/dosen/remunerasi",
};
